<app-header-one [class]="'header-gym'"></app-header-one>
<!--app-subheader [title]="'Accedi'"></app-subheader-->
<!-- <app-separator  [size]="'lg'"></app-separator> -->

<!--section class="page-header">
    <h1 class="text-dark">Accedi</h1>
</section-->
<!--section class="p-0 gym-slider">
    <div class="container py-4">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-8 col-xs-12">
                <div class="card">
                    <div class="card-header text-center">
                        <h2 class="mt-2 eit-text-color-dark">Entra in {{appInfo.APP_NAME}}</h2>
                        <div class="card-body text-center">
                            <!-<button class="btn btn-solid btn-facebook mb-3" (click)="fbLogin()">Entra con Facebook</button>
                            <p class="eit-text-color-violet">oppure</p>->
                            <form [formGroup]="loginForm" class="login-form" (ngSubmit)="login()">
                                <div class="form-group my-3">
                                    <input type="text" class="form-control" id="email" placeholder="Email" required
                                        formControlName="email" name="email">
                                </div>
                                <div class="form-group my-3">
                                    <input type="password" class="form-control" id="review" placeholder="Password" required
                                        formControlName="password" name="password">
                                </div>
                                <p><a class="eit-text-color" (click)="recovery()">Password dimenticata?</a></p>
                                <button class="btn btn-solid btn-block btn-bg-dark p-2" type="submit">Accedi</button>
                            </form>
                            <div class="mt-5">
                                <p>Non hai un account?</p>
                                <button class="btn btn-solid btn-bg-light" (click)="register()">Registrati</button>
                                <p class="mt-2">
                                    <small class="eit-text-color"> 
                                        Procedendo acconsenti ai termini e condizioni di 
                                        <a target="_blank" href="https://www.eatintime.it/terms" class="eit-text-color font-weight-bold"><ins>{{appInfo.APP_NAME}}</ins></a>.
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section-->

<section class="login-page text-center section-b-space">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8 col-sm-12 col-xs-12">
                <ul class="nav nav-tabs nav-material" id="top-tab" role="tablist">
                    <li class="nav-item">
                        <p class="nav-link" [ngClass]="{'active': selectedTab === 'login'}" (click)="selectedTab = 'login'">Login</p>
                    </li>
                    <li class="nav-item">
                        <p class="nav-link" [ngClass]="{'active': selectedTab === 'register'}" (click)="selectedTab = 'register'">Registrati</p>
                    </li>
                </ul>
                <div class="tab-pane" [ngClass]="{'active': selectedTab === 'login'}">
                    <div class="card p-0 mt-5 login-card">
                        <div class="card-body p-0 text-center">
                            <!--<button class="btn btn-solid btn-facebook mb-3" (click)="fbLogin()">Entra con Facebook</button>
                            <p class="eit-text-color-violet">oppure</p>-->
                            <form [formGroup]="loginForm" class="login-form" (ngSubmit)="loginGul()"> <!--login()-->
                                <div class="form-group my-3">
                                    <input type="text" class="form-control" id="email" placeholder="Email" required
                                        formControlName="email" name="email">
                                </div>
                                <div class="form-group my-3">
                                    <input type="password" class="form-control" id="review" placeholder="Password" required
                                        formControlName="password" name="password">
                                </div>
                                <div class="d-flex align-item-center justify-content-between">
                                    <a class="link_login d-flex align-item-center" (click)="recovery()">Password dimenticata?</a>
                                    <button class="button-primary-text button-fill-rounded" type="submit">
                                        Login
                                        <img src="assets/icons/freccia.svg">
                                    </button>
                                </div>
                            </form>
                            <div class="mt-5">
                                <p class="mt-2" *ngIf="appData && appData.link_terms && appData.link_terms.length">
                                    <small class="eit-text-color-grey">Continuando dichiari di accettare i nostri <a target="_blank"
                                        [href]="appData.link_terms" class="eit-text-color-dark-grey">Termini e Condizioni</a> e la <a target="_blank" 
                                        class="eit-text-color-dark-grey" [href]="appData.link_privacy">Privacy Policy</a>. 
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" [ngClass]="{'active': selectedTab === 'register'}">
                    <div class="card mt-5 login-card">
                        <div class="card-body text-center">
                            <form [formGroup]="regForm" class="login-form" (ngSubmit)="register()">
                                <div class="form-group my-3">
                                    <input type="text" class="form-control" id="name" placeholder="Nome" required
                                        formControlName="name" name="name">
                                </div>
                                <div class="form-group my-3">
                                    <input type="text" class="form-control" id="lastname" placeholder="Cognome" required
                                        formControlName="lastname" name="lastname">
                                </div>
                                <div class="form-group my-3">
                                    <input type="email" class="form-control" id="email" placeholder="Email" required
                                        formControlName="email" name="email">
                                </div>
                                <div class="form-group my-3">
                                    <input type="text" class="form-control" id="phone" placeholder="Telefono" required
                                        formControlName="phone" name="phone">
                                </div>
                                <div class="form-group my-3">
                                    <input type="password" class="form-control" id="review" placeholder="Password" required
                                        formControlName="password" name="password">
                                </div>
                                <ng-container *ngIf="appData">
                                    <!--div class="form-group text-start" *ngIf="appData.link_terms && appData.link_terms.length">
                                        <div class="custom-control custom-checkbox collection-filter-checkbox">
                                        <input type="checkbox" class="custom-control-input" formControlName="terms" name="terms" id="terms"/>
                                        <label class="custom-control-label" for="terms">
                                            *Ho letto, compreso e accettato le <a [href]="appData.link_terms">Condizioni generali di uso</a>
                                        </label>
                                        </div>
                                    </div>
                                    <div class="form-group text-start">
                                        <div class="custom-control custom-checkbox collection-filter-checkbox">
                                        <input type="checkbox" class="custom-control-input" formControlName="privacy" name="privacy" id="privacy"/>
                                        <label class="custom-control-label" for="privacy">
                                            *Ho letto e compreso l’<a [href]="appData.link_privacy">Informativa privacy</a>
                                        </label>
                                        </div>
                                    </div-->
                                    <div class="form-group text-start">
                                        <div class="custom-control custom-checkbox collection-filter-checkbox">
                                            <input type="checkbox" class="custom-control-input" formControlName="newsletter" name="newsletter" id="newsletter"/>
                                            <label class="custom-control-label" for="newsletter">
                                                Letta l’<a [href]="appData.link_privacy" target="_blank">Informativa privacy</a>, 
                                                acconsento  all’invio di comunicazioni commerciali e messaggi 
                                                promozionali relativi ai prodotti e servizi.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group text-start">
                                        <div class="custom-control custom-checkbox collection-filter-checkbox">
                                            <input type="checkbox" class="custom-control-input" formControlName="profiling" name="profiling" id="profiling"/>
                                            <label class="custom-control-label" for="profiling">
                                                Letta l’<a [href]="appData.link_privacy" target="_blank">Informativa privacy</a>,
                                                acconsento  all’invio di comunicazioni commerciali personalizzate e all’offerta di prodotti in linea con le mie 
                                                preferenze (c.d. profilazione)
                                            </label>
                                        </div>
                                    </div>
                                </ng-container>
                                <!-- <div class="mt-5">
                                    <p class="text-center">
                                        <small class="eit-text-color-grey">Continuando dichiari di accettare i nostri <a target="_blank"
                                            [href]="appData.link_terms" class="eit-text-color-dark-grey">Termini<br>e Condizioni</a> e la <a target="_blank" 
                                            class="eit-text-color-dark-grey" [href]="appData.link_privacy">Privacy Policy</a>. 
                                        </small>
                                    </p>
                                </div> -->
                                <button class="button-primary-text button-fill-rounded ms-auto my-3" type="submit">
                                    Registrati
                                    <img src="assets/icons/freccia.svg">
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>